import Immutable from 'immutable';
import {
  FLAG_GETTING_ACTIVITY_TASKS,
  GET_ACTIVITY_TASKS,
  CLEAR_ACTIVITY_TASKS,
  FLAG_ACTIVITY_TASK_ACTIVITY,
  CLEAR_ACTIVITY_TASK,
  GET_ACTIVITY_TASK,
} from '../../../actions/types/mechanical-maintenance';
import { COLLECTION_SHAPE } from '../../../config/shapes';

const INITIAL_STATE = Immutable.Map({
  all: Immutable.Map({
    content: Immutable.Map(COLLECTION_SHAPE),
    loading: false,
  }),
  current: Immutable.Map({
    content: Immutable.Map(),
    activity: Immutable.List(),
  }),
});

export default (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case FLAG_GETTING_ACTIVITY_TASKS:
      return state.setIn(['all', 'loading'], payload);
    case GET_ACTIVITY_TASKS:
      return state.setIn(['all', 'content'], Immutable.Map(payload));
    case CLEAR_ACTIVITY_TASKS:
      return state.setIn(
        ['all', 'content'],
        INITIAL_STATE.getIn(['all', 'content']),
      );
    case FLAG_ACTIVITY_TASK_ACTIVITY:
      if (payload) {
        return state.setIn(
          ['current', 'activity'],
          state.getIn(['current', 'activity']).push(payload),
        );
      }

      return state.setIn(
        ['current', 'activity'],
        state.getIn(['current', 'activity']).pop(),
      );
    case GET_ACTIVITY_TASK:
      return state.setIn(['current', 'content'], Immutable.Map(payload));
    case CLEAR_ACTIVITY_TASK:
      return state.setIn(['current'], INITIAL_STATE.getIn(['current']));
    default:
      return state;
  }
};
